import { Collapse, Typography } from 'antd'
import { VertCollapse } from '@vertem-core/vertice-ds';
import React from 'react'

import './collapsePopBallon.less'
import CustomExtract from '../CustomExtract/CustomExtract';
import WinnersShowcase from '../WinnersShowcase/WinnersShowcase';
import Terms from 'components/Terms/Terms';

const { Text } = Typography

const CollapsePopBallon = () => {
  const items = [
    {
      key: '1',
      label: <Text>Extrato</Text>,
      children: <CustomExtract />,
    },
    {
      key: '2',
      label: <Text>Participantes Premiados</Text>,
      children: <WinnersShowcase />,
    },
    {
      key: '3',
      label: <Text>Regulamento</Text>,
      children: <Terms />,
    }
  ];
  return (
    <div>
      <VertCollapse className='container-collapse' items={items} defaultActiveKey={'1'} />
      <div className="container-legaltxt">
        <span>Promoção válida para Produtores Rurais cadastrados no Acessa Agro e que cumpram os critérios estabelecidos em
          regulamento, no período de 01/05/2024 a 31/05/2024.Consulte demais condições no regulamento. Certificado de
          autorização SPA/ME N°05.033167/2024.
        </span>
      </div>
    </div>
  )
}
export default CollapsePopBallon